import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

import type { UpdateNpsPayload } from './types';

import { request } from '../request';

export const useUpdateNps = () => {
  return useMutation({
    mutationFn: async (body: UpdateNpsPayload) => {
      const response = await request('/nps', { method: 'PATCH', body });

      // TODO: Schema validation
      const { nps } = z.object({ nps: z.unknown() }).parse(response);

      return nps as { id: number };
    },
  });
};
